module.exports = __webpack_public_path__ + "assets/d934553e10038c6af3e2985e4fef78c0.mp4";